import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultContact = {};

export default {
  actions: {
    async [actions.DO_CREATE_EVENT_CONTACT]({ commit }, params) {
      const { data } = await HTTP.post('/event_contacts', params);
      commit(mutations.SET_EVENT_CONTACT, data.data.event_contacts[0]);
      return data;
    },
    async [actions.DO_DELETE_EVENT_CONTACT]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/event_contacts/${id}`, params);
      commit(mutations.SET_EVENT_CONTACT, data.data.event_contacts[0]);
      return data;
    },
    async [actions.DO_GET_EVENT_CONTACT]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/event_contacts/${id}`, { params });
      commit(mutations.SET_EVENT_CONTACT, data.data.event_contacts[0]);
      return data;
    },
    async [actions.DO_UPDATE_EVENT_CONTACT]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/event_contacts/${id}`, params);
      commit(mutations.SET_EVENT_CONTACT, data.data.event_contacts[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_EVENT_CONTACT]: state => state.contact,
  },
  mutations: {
    [mutations.SET_EVENT_CONTACT](state, contact) {
      state.contact = contact;
    },
    [mutations.SET_EVENT_CONTACT_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.contact;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
  },
  state: {
    contact: Object.assign({}, defaultContact),
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/event_contact.js